import React from 'react';

function SkillCard(props) {
    return(
        <div className='skill-card' style={{'--title-color': props.titleBorderColor}}>
            <div className="skill-card-content">
                <div className="skill-card-icon">
                    {props.icon}
                    {console.log(props.icon)}
                </div>
                <h2 className="skill-card-title">
                    {props.title}
                    <div></div>
                </h2>
                <p className="skill-card-text">{props.text}</p>
            </div>
        </div>
    )
}

export default SkillCard;